import React from 'react';
import { Navigation } from '../components/Navigation';
import { SaleHero } from '../components/SaleHero';
import { SaleWhyUs } from '../components/SaleWhyUs';
import { SaleServices } from '../components/SaleServices';
import { SaleFAQ } from '../components/SaleFAQ';
import { Consultation } from '../components/Consultation';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
export function SalePage() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-679" data-mp="gbj5ez8ed3r1">
      <Navigation data-id="element-680" data-mp="q8fep764dtwn" />

      <main className="pt-[72px]" data-id="element-681" data-mp="q6uize82k4x7">
        {' '}
        {/* Add padding top to account for fixed navigation */}
        <SaleHero data-id="element-682" data-mp="la43ot439dcu" />
        <Consultation data-id="element-683" data-mp="l9kovl9qj531" />
        <SaleWhyUs data-id="element-684" data-mp="2rz8zc8uyt1bi" />
        <SaleServices data-id="element-685" data-mp="2ryquwoy5fgsi" />
        <SaleFAQ data-id="element-686" data-mp="2s01x4kby4ghi" />
        <Consultation data-id="element-687" data-mp="2rziqhzrqxeis" />
      </main>

      <Footer data-id="element-688" data-mp="2n05vgrqq1154" />
    </div>;
}